<!--
 * @Author: 田鑫
 * @Date: 2022-01-07 14:41:18
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-10 09:58:25
 * @Description: 
-->

<template>
  <div class="calendar-container box-shadow">
    <div class="operation-header">
      <div class="title">
        <span class="year">{{ currentYear }}年，</span>
        <span class="month">{{ currentMonth }}月</span>
      </div>
      <el-button type="primary" icon="el-icon-arrow-left" @click="prevMonth"
        >上月</el-button
      >
      <el-button type="primary" @click="nextMonth"
        >下月<i class="el-icon-arrow-right el-icon--right"></i
      ></el-button>
    </div>
    <div class="calendar-header">
      <div
        class="header calendar-box"
        v-for="(item, index) in calendarHeader"
        :key="index"
      >
        <span class="title">{{ item }}</span>
      </div>
    </div>
    <div class="calendar-content">
      <div
        class="calendar-box content"
        v-for="(item, index) in monthContainer"
        :key="index"
      >
        <div>
          <span class="title">{{ item }}</span>
          <el-popover
            placement="top-start"
            title="标题"
            width="200"
            trigger="hover"
          >
            <!-- <el-button slot="reference">hover 激活</el-button> -->
            <div class="slot" slot="reference">123123 123123 123123 1231</div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hxCalendar",
  data() {
    return {
      defaultYear: new Date().getFullYear(),
      currentYear: new Date().getFullYear(),
      defaultMonth: new Date().getMonth() + 1,
      currentMonth: new Date().getMonth() + 1,
      calendarHeader: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期天",
      ],
      totalDaysInAMonth: 0,
      monthContainer: [],
      gridData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.renderCalendar(this.defaultYear, this.defaultMonth);
  },
  //生命周期 - 方法
  methods: {
    /**
     * @description: 渲染日历
     * @param {*} year
     * @param {*} month
     * @return {*}
     */
    renderCalendar(year = this.defaultYear, month = this.defaultMonth) {
      this.monthContainer = [];
      this.currentYear = year;
      this.currentMonth = month;
      this.totalDaysInAMonth = this.getTotalDaysInAMonth(year, month);
      for (let i = 0; i < this.totalDaysInAMonth; i++) {
        this.monthContainer.push(i + 1);
      }
      this.firstDayInMonth = this.getMonthFirstDay(year, month);
      if (this.firstDayInMonth) {
        for (let i = 0; i < this.firstDayInMonth - 1; i++) {
          this.monthContainer.unshift("空");
        }
      }
    },
    /**
     * @description: 获取一个月内的总天数
     * @param {*} year
     * @param {*} month
     * @return {*}
     */
    getTotalDaysInAMonth(year, month) {
      if (year && month) {
        return new Date(year, month, 0).getDate();
      } else {
        return new Date(this.defaultYear, this.defaultMonth, 0).getDate();
      }
    },
    /**
     * @description: 获取一个月的第一天为星期几
     * @param {*} year
     * @param {*} month
     * @return {*}
     */
    getMonthFirstDay(year, month) {
      console.log(year);
      console.log(month);
      if (year && month) {
        return new Date(year, month - 1).getDay();
      } else {
        return new Date(this.defaultYear, this.defaultMonth - 1).getDay();
      }
    },
    /**
     * @description: 上月
     * @param {*}
     * @return {*}
     */
    prevMonth() {
      let prevYear, prevMonth;
      if (this.currentMonth === 1) {
        prevYear = this.currentYear - 1;
        prevMonth = 12;
      } else {
        prevYear = this.currentYear;
        prevMonth = this.currentMonth - 1;
      }
      this.renderCalendar(prevYear, prevMonth);
    },
    /**
     * @description: 下月
     * @param {*}
     * @return {*}
     */
    nextMonth() {
      let nextYear, nextMonth;
      if (this.currentMonth === 12) {
        nextYear = this.currentYear + 1;
        nextMonth = 1;
      } else {
        nextYear = this.currentYear;
        nextMonth = this.currentMonth + 1;
      }
      this.renderCalendar(nextYear, nextMonth);
    },
  },
};
</script>
<style lang='scss' scoped>
.calendar-container {
  border-radius: 6px;
  padding: 15px;
  .box-shadow {
    box-shadow: 0 0 5px 4px rgba(0, 0, 0, 0.05);
  }
  .calendar-box {
    width: 14.2%;
    height: 0;
    padding-bottom: 14.2%;
    // border: 1px #e8e8e8 solid;
    // border-right: none;
  }
  .operation-header {
    display: flex;
    margin-bottom: 20px;
    .title {
      font-weight: 700;
      color: #000;
      .year {
        font-size: 24px;
      }
      .month {
        font-size: 22px;
      }
    }
  }
  .calendar-header {
    width: 800px;
    display: flex;
    .header {
      text-align: right;
      .title {
        padding: 5px;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
  .calendar-content {
    width: 800px;
    display: flex;
    flex-wrap: wrap;
    text-align: right;
    .content {
      cursor: pointer;
      .slot {
        padding: 10px;
      }
    }
    .content:hover {
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
    }
  }
}
</style>
